import type { VoidFunctionComponent } from 'react';

type Props = {
  isSmallIcon?: boolean;
};

const PipIcon: VoidFunctionComponent<Props> = ({ isSmallIcon }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={isSmallIcon ? 12 : 16} height={isSmallIcon ? 12 : 16} fill="none" viewBox="0 0 80 81"><path fill="#3776A7" d="M41 21.188h18v18H41zM41 1.188h18v18H41zM21 21.188h18v18H21z" /><path fill="#FED342" d="M41 61.188h18v18H41zM41 41.188h18v18H41zM21 61.188h18v18H21z" /><path fill="#3776A7" d="M1 21.188h18v18H1zM21 1.188h18v18H21z" /><path fill="#FED342" d="M61 21.188h18v18H61z" /><path fill="#3776A7" d="M1 41.188h18v18H1z" /><path fill="#FED342" d="M61 41.188h18v18H61zM21 41.188h18v18H21z" /><circle cx="50" cy="70.188" r="4" fill="#fff" /><circle cx="30" cy="10.188" r="4" fill="#fff" /></svg>
  );
};

export default PipIcon;
